

import React from 'react';
import { FaPlay } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { GoClockFill } from "react-icons/go";
import "../../ReusableComponent/CIVIL/CivilCard/CivilCard.css";
import ShareComponent1 from '../../ShareComponent/ShareComponent1';
import aboutimg from "../../../Image/aboutimg.png"

function convertTimestamp(originalTimestamp) {
    const originalDate = new Date(originalTimestamp);
    return originalDate.toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });
}

function isValidUrl(string) {
    try {
        new URL(string);
        return true;
    } catch (_) {
        return false;
    }
}

const stripHtmlAndTruncate = (html, title = '', length = 5000) => {
    if (!html) return '';

    let text = html;

    // Quick check: if it looks like JSON, try to parse it
    if (typeof html === 'string' && (html.startsWith('[') || html.startsWith('{'))) {
        try {
            const parsed = JSON.parse(html);
            if (Array.isArray(parsed)) {
                text = parsed.map(p => p.text || '').join(' ');
            }
        } catch (e) {
            // Not valid JSON, fall back to string processing
        }
    }

    // 1. Remove style, script, xml, head tags and their contents (this fixes the VML issue)
    text = text.replace(/<(style|script|xml|head)\b[^>]*>[\s\S]*?<\/\1>/gi, '');

    // 2. Remove HTML comments and Word-specific conditional comments
    text = text.replace(/<!--[\s\S]*?-->/g, '');
    text = text.replace(/<!\[[\s\S]*?\]>/g, '');

    // 3. ULTRA-AGGRESSIVE cleaning for Word/VML junk
    // This catches the exact pattern: v:* {behavior...} ... X-NONE X-NONE
    text = text.replace(/[vow]\\?:\*[\s\S]*?X-NONE\s+X-NONE/gi, '');
    text = text.replace(/\.shape[\s\S]*?X-NONE\s+X-NONE/gi, '');
    
    // Remove any remaining CSS rules that might have survived (selector { properties })
    text = text.replace(/[a-z0-9\\?:\*\.-]+\s*\{[^{}]*\}/gi, '');
    
    // Remove common Word metadata strings
    text = text.replace(/Normal\s+0\s+false\s+false\s+false\s+false\s+EN-US\s+X-NONE\s+X-NONE/gi, '');
    text = text.replace(/mso-[a-z-]+:[^;]+;/gi, ''); // Remove mso properties
    text = text.replace(/\{[^}]*behavior\s*:\s*url\s*\([^)]*VML[^)]*\)[^}]*\}/gi, '');

    // 4. Replace other tags with space instead of empty string to avoid words merging
    text = text.replace(/<[^>]*>?/gm, ' ');

    // 5. Handle common HTML entities
    text = text.replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&rsquo;/g, "'")
        .replace(/&lsquo;/g, "'")
        .replace(/&ldquo;/g, '"')
        .replace(/&rdquo;/g, '"')
        .replace(/&quot;/g, '"')
        .replace(/&mdash;/g, '—')
        .replace(/&ndash;/g, '–')
        .replace(/&hellip;/g, '…');

    // 6. Remove multiple spaces and trim
    text = text.replace(/\s+/g, ' ').trim();

    // If content starts with the title, remove it
    if (title && typeof title === 'string') {
        const cleanTitle = title.trim();
        const normalizedTitle = cleanTitle.toLowerCase().replace(/[^a-z0-9]/g, '');
        
        // Check first 200 chars for a normalized match of the title
        const searchRange = text.substring(0, Math.max(cleanTitle.length + 100, 200));
        const normalizedSearch = searchRange.toLowerCase().replace(/[^a-z0-9]/g, '');
        
        if (normalizedSearch.startsWith(normalizedTitle)) {
            let skipIndex = -1;
            const textForSearch = text.toLowerCase().replace(/[’‘]/g, "'");
            const titleForSearch = cleanTitle.toLowerCase().replace(/[’‘]/g, "'");
            
            if (textForSearch.startsWith(titleForSearch)) {
                skipIndex = titleForSearch.length;
            } else {
                const index = textForSearch.indexOf(titleForSearch);
                if (index !== -1 && index < 100) {
                    skipIndex = index + titleForSearch.length;
                }
            }
            
            if (skipIndex !== -1) {
                text = text.substring(skipIndex).trim();
            }
        }
    }

    // AGGRESSIVE HEADER SKIPPING
    const headersToSkip = [
        /^INTRODUCTION\b/i,
        /^WHY IN NEWS\b/i,
        /^BACKGROUND\b/i,
        /^CONCLUSION\b/i,
        /^EXPLANATION\b/i,
        /^SUMMARY\b/i,
        /^CONTEXT\b/i
    ];
    
    let changed = true;
    while (changed) {
        changed = false;
        text = text.replace(/^[:\-\s\u2013\u2014\.\,]+/, '').trim();
        for (let regex of headersToSkip) {
            if (regex.test(text)) {
                text = text.replace(regex, '').trim();
                changed = true;
                break;
            }
        }
    }
    
    // Final trim
    text = text.replace(/^[:\-\s\u2013\u2014\.\,]+/, '').trim();

    return text.length > length ? text.substring(0, length) + "..." : text;
};

function BlogCard({ CardData }) {


    return (
        <>
            {CardData.map((item, index) => {
                const rawContent = (item.Subtitle && item.Subtitle.trim() !== '') 
                    ? item.Subtitle 
                    : (item.subtitle && item.subtitle.trim() !== '')
                        ? item.subtitle
                        : (item.Description || item.description || '');

                return (
                    <div className='blogCard-background' key={index}>
                        <div className="blogCard-box">
                            <h6>
                                <Link className='list-group-item'>
                                    {item.Title}
                                </Link>
                            </h6>
                            <div className='blogcard-box2'>
                                <div className="text-center BlogCard-imgs">
                                    <Link to={`/blog/${item.TitleUrl}`} className='list-group-item'>
                                        <img src={isValidUrl(item.Image) ? item.Image : aboutimg} className='BlogCard-img' alt={`Images ${index}`} loading="lazy" />
                                        <p className='fw-bold pt-3'>By : {item.WrittenBy}</p>
                                    </Link>
                                </div>
                                <div className="blogcardtext d-flex justify-content-between">
                                    <div className='blog-box1'>
                                        <div className=''>
                                            <p className='blog-text'>
                                                {stripHtmlAndTruncate(rawContent, item.Title, 400)}
                                            </p>
                                        <p><GoClockFill /> {convertTimestamp(item.PublishDate)}</p>
                                        {/* <div className="blog-box2">
                                            <Link to={`/blog/${item.TitleUrl}`} className='list-group-item bg-purepurple p-2 d-flex justify-content-center align-items-center fw-bold text-white'>Read More <FaPlay className='text-pureorange' /></Link>
                                        </div> */}
                                    </div>
                                    <div className="blog-box2 justify-content-end">
                                        <Link to={`/blog/${item.TitleUrl}`} className='list-group-item bg-darkblue p-2 d-flex justify-content-center align-items-center fw-bold text-white'>Read More <FaPlay className='ms-2 text-pureorange' /></Link>
                                        {/* <Link to={`/blog/${item.TitleUrl}`} className='p-2 d-flex justify-content-center align-items-center'>read more</Link> */}
                                    </div>
                                    {/* <ShareComponent1 index={index} url={item.TitleUrl}/> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        })}
        </>
    )
}

export default BlogCard;
